 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		82: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","5":"legacyIbdPage","7":"ad-AdContainer","8":"components-analytics-analytics","9":"components-feature_feed-feature_feed","10":"container","11":"fc_executive_board","12":"fc_link-fc_link","13":"post-content-body","14":"aboutUsWpPage","15":"author","16":"category_page","17":"components-not_found_component-not_found_component","18":"components-slug-slug","19":"customCollectionPage","20":"feed","21":"loginPage","22":"logoutPage","23":"magazineTagPage","24":"magazine_page","25":"myAccountPage","26":"newsletters_page_marketo","27":"notFoundPage","28":"offerPage","29":"playlistIndexPage","30":"playlistPage","31":"podcastPage","32":"post_page","33":"registerPage","34":"resetPasswordPage","35":"sitemapIndex","36":"sitemapPost","37":"stories","38":"subscribePage","39":"tagPage","40":"videoIndex","41":"videoPage","42":"views-containers-layouts-blank_layout-blank_layout","43":"views-containers-layouts-web_layout-web_layout","77":"MarketoNewsletterForm","78":"MicCarousel","79":"MicIcon","80":"MicMobileIconCarousel","81":"Success-SubmissionSuccess","83":"applications-most-innovative-companies","84":"brands_that_matter_list_page","85":"brands_that_matter_page","86":"categoryLink","87":"components-BackgroundHighlight-BackgroundHighlight","88":"components-MultiTabList-MultiTabList","89":"components-QuickCarousel-QuickCarousel","90":"components-StickyBar-StickyBar","91":"components-all_feed-all_feed","92":"components-categories","93":"components-config-config","94":"components-editor_highlights-editor_highlights","95":"components-finite_scroll","96":"components-footer-footer","97":"components-franchise_intro-franchise_intro","98":"components-ibd_category-ibd_category","99":"components-image-image","100":"components-magazine_archive-magazine_archive","101":"components-masthead-masthead","102":"components-mcp_section-mcp_section","103":"components-mic_mobile_menu-mic_mobile_menu","104":"components-more-stories-component-more-stories-component","105":"components-newsletters-recaptcha","106":"components-notice","107":"components-piano-pianoBottomBanner","108":"components-podcast_tile-podcast_tile","109":"components-podcast_tile-podcast_tile_featured","110":"components-post-content-insert","111":"components-ranked","112":"components-recirc-recirc","113":"components-related_posts-related_posts","114":"components-related_slider-related_slider","115":"components-sectors_list-sectors_list","116":"components-social","117":"components-social-social","118":"components-top_50-top_50","119":"components-top_50_shuffle-top_50_shuffle","120":"components-video_megatron-video_megatron","121":"components-video_module-utils-video_module_ads","122":"components-video_module-video_module","123":"containers-pages-list_landers-bwi-2020","124":"containers-pages-list_landers-ibd-2020","125":"containers-pages-list_landers-mic-2021","126":"content-innovation_festival_banner","127":"content-sponsor_bar","128":"fc-components-main-components","129":"fc-components-main-components-StickyBar-StickyBar","130":"fc-components-main-containers","131":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","132":"fc-components-main-containers-IbdLayout-IbdLayout","133":"fc-components-main-containers-WciLayout-WciLayout","134":"fc-components-main-utils-ConditionalWrapper","135":"franchises-BtmApplyPage","136":"franchises-BwiApplyPage","137":"franchises-IbdApplyPage","138":"franchises-MicApplyPage","139":"franchises-NbttApplyPage","140":"franchises-WciApplyPage","141":"innovation_by_design_future_page","142":"innovation_by_design_page_franchise","143":"innovation_by_design_page_franchise_2023","144":"layouts","145":"layouts-mcp","146":"nav_main_menu-nav_main_menu","147":"package_article_list_entry","148":"packages-nav-package_sticky_nav","149":"post-content-sidebar"}[chunkId]||chunkId) + "." + {"1":"1e48ec36d8189476c003","2":"b180b867f1ad7937f5f1","3":"3c21caed2dfc27c50df5","4":"91d6a0e2db9256b4a636","5":"cb4cdcf9b3532c59eb9c","6":"e0abf6a9ef4a63356b9e","7":"0982d32060c552027349","8":"87a95360ba4e20213f4a","9":"993c2f6be9e12edb41bc","10":"d6cc4582f391869d3640","11":"49f34f1ae1920eebdee6","12":"f772a8d90386e8690781","13":"5995bfc9721e116e380c","14":"b3ac371e18fbc0f9c977","15":"8d41cd8c06101ebad685","16":"848e4c6826463afd5660","17":"96504a123d61b7bf25ef","18":"43c02dbec3e441fd7d76","19":"bbbc1e5e1ca92859e163","20":"0e71c1a67251fc9d3329","21":"1845b9556b05be57e135","22":"40ab32dc5085d7b00e59","23":"053904e208692e843433","24":"c94495989106d010db2d","25":"7fe6c54e2e24bffcea0b","26":"6b06d6529f2778e6c923","27":"b7bcbdb4776766bf4561","28":"463c95cdc7f9b6f30efc","29":"a6e0296b86e9af3d1578","30":"244fc84172b426580ef6","31":"ec9c96c52a17485a0ee7","32":"62119a0ae6ad6de8c729","33":"9aeb528126089f95043b","34":"c148b2d593d3153e16e9","35":"1374847b97a226387918","36":"0d3408c37ab87eed7e00","37":"5a271021d765cf6fb141","38":"5bfefe91f513b964d1cb","39":"576bb57339f80131e3d3","40":"a47c0e220fb61381aa37","41":"ad9a6df58e9f6ba61dee","42":"f6f0a661c17f240e2668","43":"5367ec08f2336f7abccb","44":"8ef946c0b5883592e81d","45":"c38b2f554d62ef4e12d4","46":"95f289aba45bca88b038","47":"cea74846e350b4705bba","48":"1db8c8b2632424322b67","49":"1ae309e08d39763b9801","50":"07b7a20743b57091aa44","51":"7f0910abd8ad3eef3e03","52":"f5d106dcdf55c783e0de","53":"cd4940645e0166de64a2","54":"8b9316ffc9d7e1c65fec","55":"1af510b9dc387959629f","56":"ad52eb58b1d370e662c3","57":"56c5f7e1c867d58621ea","58":"14af5cd3458007e7ea4a","59":"430948db16bdec0e3afd","60":"242feae72169c717fb9d","61":"e9b5b62687ceb9ff6ebd","62":"cc7c7bf192fb4aedf784","63":"804560002293614c8317","64":"d362955594a47a706181","65":"7463bef5004d228ece91","66":"c9d2ee1baf75ab714ae4","67":"7ca912c1d49ce14106d3","68":"b134e121e1560e89e53c","69":"d7120385a755b76432a1","70":"6b37551b77261d11e7f0","71":"fb2ab5ed5e859f266edc","72":"41577be1ea56ff184c7c","73":"8802baec6c1c29855360","74":"92fb286b0b957b6d042e","75":"e6c70688578266ee7bc4","76":"4cd5774b2c8a61837af1","77":"3981381ebe40e64eeb8c","78":"72e053d0b5531e370037","79":"660c80bc7db91f9d25ec","80":"90a44bbf8a4b56afd06b","81":"0fb76c7029cecc8957fe","83":"9b54d5ec2d452d313d58","84":"5592c1abfcfabb46491d","85":"64cd38e05939f3d70996","86":"239b77d14311ae0d5588","87":"1624e120440ed710182e","88":"d4ab7ba8eca3701b1498","89":"2257492156f235ea4ade","90":"1c8a6e3e2cb673842f28","91":"f95db5f877bb6da772f5","92":"011fc41144ebd9122a70","93":"f6f1262a914bc06cd8c8","94":"c4564085ce2ad886a5d9","95":"ab6b400d98415ba18f65","96":"adc16e6da2bf591a70f1","97":"9927cda38bbaad706a1e","98":"02273f085b5c636ebd04","99":"6e5a6a6a8a28c399253f","100":"f62d0ef90402c2b8f00e","101":"9204eef6f9a258f623ff","102":"2928fd8fedcb39147501","103":"17dfb1cd3a718033f605","104":"9028ac89ecea71635a99","105":"1126299d1ccb865b5b47","106":"0a6cf73fbcc59807bbc5","107":"9971a956d780caee7f01","108":"603f78c62742f0f19368","109":"96822e916c8399974baf","110":"8669067fbfe8e7410e8a","111":"ddb656f2842a19fbbd6b","112":"d65653b32442619326ee","113":"32e88e5561b3ae671b16","114":"75d63adfe894893561e5","115":"713949fd75ca3f645604","116":"36c37de2caed473740f5","117":"6ae2be4225389b3e9fb3","118":"03292896ecb69e4201e2","119":"ea397c09bcfc4d6825b0","120":"ec9aec3c80c55c9cb87b","121":"4eca46a2f3114a76fecd","122":"27601b35264a741849d8","123":"4237b06f190369c00a33","124":"d4687133d35150c49cd2","125":"aac5d29d99064121eabc","126":"8515f6a11de630bbb014","127":"29381f78b4e340828d45","128":"00c7446e473e32a06c65","129":"d3c1bb49231c5b224254","130":"13b15ed0a380cd6e83e3","131":"84b26fbf94dcc625e363","132":"c5d691b3b1e5b50bd156","133":"0a1689eafc2f21f020ae","134":"308ae80542ee1a914d9f","135":"0e8d32c529852429603a","136":"7f83e02fd441369caaa0","137":"5b4eed198ca612c57d24","138":"1b9a419d7bbb75c72d65","139":"674a1905e31f9eff0368","140":"7c55ddb7d048463e52d5","141":"16541e579feaaeefe16f","142":"c5570accc4e44bb8ad21","143":"6d3f2eaea95aef77f6b8","144":"68b81dab1e2dfa7cf369","145":"8054bdbb975e790418f5","146":"a64da8110f70c149e8af","147":"1ff9bae948a537c3d8b4","148":"c34306fab9d474043a1a","149":"9fd4be31f16c5de0c5eb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([742,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
